export const salesStatsGroupBy = {
  DAY: 'DAY',
  HOUR: 'HOUR',
}
